<template>
  <div id="landing">
    <SectionUseful />
    <SectionNeeds />
    <SectionAsapLoan />
    <SectionLoanFee />
    <SectionFooter />
  </div>
</template>

<script>
import SectionUseful from '@/components/landing/SectionUseful.vue'
import SectionNeeds from '@/components/landing/SectionNeeds.vue'
import SectionAsapLoan from '@/components/landing/SectionAsapLoan.vue'
import SectionLoanFee from '@/components/landing/SectionLoanFee.vue'
import SectionFooter from '@/components/landing/SectionFooter.vue'

export default {
  components: {
    SectionUseful,
    SectionNeeds,
    SectionAsapLoan,
    SectionLoanFee,
    SectionFooter,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

#landing {
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  :deep(section) {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  :deep(.landing-container) {
    max-width: $standard-max-width;
    margin: 0 auto;
  }
}
</style>
